import { Box, TextField } from '@mui/material';
import { useMemo } from 'react';

const InvoicesAmountRange = ({ amounts, setAmounts, gap }) => {
    const minValue = amounts?.min ? parseFloat(amounts.min) : null;
    const maxValue = amounts?.max ? parseFloat(amounts.max) : null;
    
    const isMaxInvalid = useMemo(() => {
        if (minValue === null || maxValue === null) return false;
        return maxValue < minValue;
    }, [minValue, maxValue]);

    const renderAmountTextField = (value) => {
        const isError = value === 'max' && isMaxInvalid;
        return (
            <TextField
                size="small"
                placeholder={`${value} Amount`}
                aria-label={value}
                value={amounts[value] || ''}
                onChange={(e) => setAmounts({ ...amounts, [value]: e.target.value })}
                type="number"
                error={isError}
                InputProps={{
                    inputMode: 'numeric',
                    endAdornment: amounts[value] && (
                        // <HiOutlineXCircle
                        //     className="iconButton pointer"
                        //     onClick={() => setAmounts({ ...amounts, [value]: '' })}
                        // />
                        (<></>)
                    ),
                }}
            />
        );
    }

    return (
        <Box display={"flex"} gap={gap}>
            {renderAmountTextField('min')}
            {renderAmountTextField('max')}
        </Box>
    );
};  
  
export default InvoicesAmountRange;